import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryGoodsInstagrams({ page, size, direction, sort, }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-instagram`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryGoodsInstagram(instagramId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-instagram/${instagramId}`,
    method: 'get',
  });
}

export function _addGoodsInstagram(
  {
    mediaUrl,
    name,
    permalink,
    mediaType,
    caption,
    isShow,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-instagram`,
    method: 'post',
    data: {
      mediaUrl,
      name,
      permalink,
      mediaType,
      caption,
      isShow,
    },
  });
}

export function _updateGoodsInstagram(instagramId, {
  mediaUrl,
  name,
  permalink,
  mediaType,
  caption,
  isShow,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-instagram/${instagramId}`,
    method: 'patch',
    data: {
      mediaUrl,
      name,
      permalink,
      mediaType,
      caption,
      isShow,
    },
  });
}

/**
 * 删除
 * @param newsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteGoodsInstagram(instagramId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-instagram/${instagramId}`,
    method: 'delete',
  });
}

export function _updateGoodsSort({
  idStr, sortStr, oldIndex, newIndex
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website/instagram/update`,
    method: 'post',
    params: {
      idStr: idStr,
      sortStr: sortStr,
      oldIndex: oldIndex,
      newIndex: newIndex
    }
  });
}
